import { useState, useEffect, useRef, useContext } from "react";
import Select from 'react-select';
import marker from "leaflet/src/images/marker.svg"
import marker2 from '../assets/markers/marker2.svg'
import marker3 from "../assets/markers/marker3.svg"
import marker4 from "../assets/markers/marker4.svg"
import { Icon } from "leaflet";
import ContextStates from "../context/ContextStates";
import { MapContainer, TileLayer, useMap, Popup, Marker } from 'react-leaflet'
import axios from "axios";
import { Url } from "./Url";
import { useNavigate } from 'react-router-dom';

//import { useMapEvents } from 'react-leaflet/hooks'

import "leaflet/dist/leaflet.css"
const myIcon = new Icon({
    iconUrl: marker,
    iconSize: [32, 32]
})

const myIcon2 = new Icon({
    iconUrl: marker2,
    iconSize: [32, 32]
})

const myIcon3 = new Icon({
    iconUrl: marker3,
    iconSize: [32, 32]
})

const myIcon4 = new Icon({
    iconUrl: marker4,
    iconSize: [32, 32]
})


const Map = () => {
    const [map, setMap] = useState(null)
    const [zonas, setZonas] = useState([])
    const [zona, setZona] = useState(0)
    const [fechaInicio, setFechaInicio] = useState('')
    const [fechaFin, setFechaFin] = useState('')

    const [position, setPosition] = useState([-26.833018562210178, -65.20875863504794])
    const [pedidos, setPedidos] = useState([])
    const { setFormView, setViewOpen, setPedidoSelected } = useContext(ContextStates)
    const navigate = useNavigate();

    useEffect(() => {
        console.log(position)
    }, [position])

    useEffect(() => {
        const consultaPedidos = async () => {
            //console.log("zona es ",zona)
            const formData = new FormData()
            formData.append("zona", zona.id)
            try {
                const response = await axios({
                    url: Url + 'api/listadoPedidos.php',
                    method: 'POST',
                    data: formData,
                })
                console.log("pedidos", response)
                setPedidos(response.data.results)
            } catch (e) {
                console.log(e)
            }
        }
        consultaPedidos()
    }, [zona])

    useEffect(() => {
        const consultaZonas = async () => {
            const formData = new FormData()
            formData.append("id", 1)
            try {
                const response = await axios({
                    url: Url + 'api/listZonas.php',
                    method: 'POST',
                    data: formData,
                })

                setZonas(response.data.results)
            } catch (e) {
                console.log(e)
            }
        }
        consultaZonas()
    }, [])

    const handlePedido = (item) => {
        console.log("pedido sel ", item)
        setPedidoSelected(item)
        navigate("/pedido", { replace: true });
    }

    return (
        <div className="mt-1 mb-10 w-full z-0">
            <div className="w-1/2 mx-auto mb-4">
                <Select
                    options={zonas}
                    placeholder="Seleccione la zona"
                    onChange={(value) => setZona(value)}
                    name='sZona'
                />
            </div>
            <div className="w-full md:w-9/12 mx-auto bg-slate-200 mt-5 mb-5 rounded-xl">
                <div className='w-full flex'>
                    <div className='w-1/2 p-3'>
                        <label htmlFor='fechainicio'>Fecha de Inicio</label>
                        <input type='date' className='w-full p-3 rounded-lg' id='fechainicio' placeholder='Fecha de Inicio' value={fechaInicio} onChange={(e) => setFechaInicio(e.target.value)} />
                    </div>
                    <div className='w-1/2 p-3 ml-5 rounded-xl'>
                        <label htmlFor='fechafin'>Fecha de Fin</label>
                        <input type='date' className='w-full p-3 rounded-lg' id='fechafin' placeholder='Fecha de Fin' value={fechaFin} onChange={(e) => setFechaFin(e.target.value)} />
                    </div>
                </div>
            </div>

            <MapContainer
                center={position}
                zoom={20}
                scrollWheelZoom={true}
                className="mx-auto h-full bg-red-500 z-0"
                whenReady={setMap}
                style={{
                    maxWidth: '80vw',
                    height: 800
                }}>
                <TileLayer
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                {pedidos && pedidos.map((item, index) => (
                    <Marker
                        key={index}
                        position={[item.latitud, item.longitud]}
                        icon={item.marker === 0 ? myIcon3 : item.marker === 1 ? myIcon : item.marker === 2 ? myIcon4 : myIcon2}
                        onClick={() => setPosition([item.latitud, item.longitud])}
                    >
                        <Popup>
                            Nombre: {item.apellido} <br />Fecha de pedido: {item.fecha} <br />Hora de pedido: {item.hora}
                            {item.marker === 1 && (
                                <button
                                    className="bg-blue-500 text-white p-3 w-full rounded"
                                    onClick={() => handlePedido(item)}
                                >Ver Pedido</button>
                            )}
                        </Popup>
                    </Marker>
                ))}
            </MapContainer>

        </div>
    )
}

export default Map
